import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=635afc90&scoped=true"
import script from "./Resultado.vue?vue&type=script&lang=js"
export * from "./Resultado.vue?vue&type=script&lang=js"
import style0 from "./Resultado.vue?vue&type=style&index=0&id=635afc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635afc90",
  null
  
)

export default component.exports